import styled from "styled-components";

const StyledContainer = styled.div`
  .ant-breadcrumb {
    color: #052c2b;
    font-size: 12px;
    padding: 16px 22px;
  }

  header {
    padding: 16px 32px;

    h2 {
      font-size: 21px;
      margin: unset;
    }
  }

  .ant-tabs {
    .ant-tabs-nav .ant-tabs-nav-wrap {
      border-bottom: 1px solid #c9c8c8;
    }

    .ant-tabs-nav .ant-tabs-ink-bar {
      height: 4px;
      background: #052c2b;
      border-radius: 4px 4px 0 0;
    }

    .ant-tabs-tab:first-of-type {
      margin-left: 32px;
    }
  }

  .container-permission {
    border-bottom: 1px solid rgba(201, 200, 200, 0.5);
    display: flex;
    gap: 44px;
    padding: 32px;

    h4 {
      color: #1e1919;
      font-size: 16px;
      margin: unset;
      width: 176px;
    }

    .container-values {
      width: 412px;

      .divider {
        border-bottom: 1px solid #c9c8c8;
      }

      .ant-form-item .ant-form-item-control-input-content {
        display: flex;
        justify-content: end;
      }

      .ant-form-item {
        margin-bottom: unset;
      }
    }
  }
`;

export default StyledContainer;
